var collapsible_list_pair_rtlignore_default = {
  "container": "ArmWk",
  "title": "ltUS4",
  "viewerContainer": "sqe2g",
  "titleContainer": "wG1jD",
  "content": "Ic98Q",
  "expandIcon": "j5KfA",
  "dndIcon": "_9QY74",
  "RTL": "O6Pcr",
  "LTR": "B32EG",
  "itemContainer": "_6MALF",
  "itemContainerViewer": "MZ-cX",
  "mouseDown": "LdFi2",
  "innerEditor": "rqFTi",
  "item": "qh9VW",
  "floatingAddPluginMenuWrapper": "dvNFr"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
